import { render } from "./DirectionsComponent.vue?vue&type=template&id=663b1334&ts=true"
import script from "./DirectionsComponent.ts?vue&type=script&lang=ts&external"
export * from "./DirectionsComponent.ts?vue&type=script&lang=ts&external"

import "./DirectionsComponent.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__